import * as React from "react"

import { cn } from "@/lib/utils"

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          // The 3px focus glow is a `ring`, not a `shadow`: chromeless embeds
          // (sidebar search, header filters, inline renames) suppress it with
          // `focus-visible:ring-0`, and tailwind-merge can only strip a
          // conflicting utility from the same group + variant. A
          // `focus-visible:shadow-*` glow survives a base `shadow-none`.
          "border-input file:text-foreground placeholder:text-muted-foreground focus-visible:border-primary focus-visible:ring-primary/15 flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-base shadow-sm transition-[box-shadow,border-color] duration-200 ease-out file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-3 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
